import { render, staticRenderFns } from "./PricingBotMessage.vue?vue&type=template&id=a12e79c4&"
import script from "./PricingBotMessage.vue?vue&type=script&lang=js&"
export * from "./PricingBotMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports